import * as React from 'react';

import SideBarLink from './SidebarLink';

class SidebarView extends React.Component {

    render(){
        return(
            <div className="sidebar-view">
                <SideBarLink path='/home' iconName='Home' description='Startside' color="#112f55" title='' fullWidth={true}   />
                <SideBarLink path='/ukeplan' iconName='Calendar' description='Ukeplan lærer' title='Ukeplan' />
                <SideBarLink path='/innleveringer' iconName='CompletedSolid' description='Innlevering lærer' title='Innlevering' />
                <SideBarLink path='/timeplan' iconName='ViewAll' description='Timeplan lærer'  title='Timeplan' />
                <SideBarLink path='/quiz' iconName='PageListSolid' description='Prøver' title='Prøver' />
                <SideBarLink path='/portefolje' iconName='FabricOpenFolderHorizontal' description='Portefølje for lærer' title='Portefølje' />
                <SideBarLink path='/meldinger' iconName='Message' description='Dashboard for meldinger for lærer' title='Meldinger' />
                <SideBarLink path='/iup' iconName='Transition' description='IUP' title='IUP' />
                <SideBarLink path='/admin' iconName='Settings' description='Administrasjon for lærer' title='Admin' />
                <SideBarLink path='/discovery' iconName='Search' description='Søkesenter' title='Søkesenter' />
            </div>
        )
    }
}

export default SidebarView;